<div class="container my-3 p-3 justify-content-center">
    <navbar></navbar>
    <router-outlet></router-outlet>
</div>